import { render, staticRenderFns } from "./Fonteffects.vue?vue&type=template&id=53c510a2&"
import script from "./Fonteffects.vue?vue&type=script&lang=js&"
export * from "./Fonteffects.vue?vue&type=script&lang=js&"
import style0 from "./Fonteffects.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports